// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const RefundSettlementStatus = {
  PendingSettlement: {
    Name: 'Pending Settlement',
    Value: 'pending_settlement',
  },
  PartiallySettled: {
    Name: 'Partially Settled',
    Value: 'partially_settled',
  },
  Settled: {
    Name: 'Settled',
    Value: 'settled',
  },
  Failed: {
    Name: 'Failed',
    Value: 'failed',
  },
} as const

export type RefundSettlementStatusValue =
  (typeof RefundSettlementStatus)[keyof typeof RefundSettlementStatus]['Value']
